import { render, staticRenderFns } from "./contentIntroduction.vue?vue&type=template&id=cb64c662&scoped=true"
import script from "./contentIntroduction.vue?vue&type=script&lang=js"
export * from "./contentIntroduction.vue?vue&type=script&lang=js"
import style0 from "./contentIntroduction.vue?vue&type=style&index=0&id=cb64c662&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb64c662",
  null
  
)

export default component.exports